import { Box, TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import DocumentUpload from "components/UI/documentUpload/DocumentUpload";
import AdvancedInputField from "components/UI/AdvancedInputField/AdvancedInputField";

const DatePicker = ({
  hasRange = false,
  submittedAnswer,
  handleQuesAnswer,
  isFrom,
  event,
  comment,
  question,
  hasAttachedDocument,
}) => {
  const [data, setData] = useState({
    startDate: "",
    endDate: "",
    comment: "",
  });

  const [attachDocument, setAttachDocument] = useState(null);

  useEffect(() => {
    if (submittedAnswer?.length > 0) {
      setData({
        startDate: submittedAnswer?.[0]?.startDate || "",
        endDate: submittedAnswer?.[0]?.endDate || "",
        comment: submittedAnswer?.[0]?.comment || "",
      });

      setAttachDocument(submittedAnswer[0]?.supporting_document || null);
    } else {
      setData({ startDate: "", endDate: "", comment: "" });
    }
  }, []);

  const formatDate = (dateString) => dateString?.split("T")[0] || "";

  const handleChange = (key, value) => {
    const updatedData = { ...data, [key]: value };
    setData(updatedData);

    if (key === "document") setAttachDocument(value);

    if (isFrom === "taskSection") {
      const obj = {
        startDate: updatedData.startDate,
        endDate: updatedData.endDate,
        comment: updatedData.comment,
        weightage: 1,

        supporting_document:
          key === "document" && value === null ? value : attachDocument,
        document: key === "document" ? value : attachDocument,
        documentMetaData:
          key === "document"
            ? {
                ques_id: question?._id,
                name: value?.name,
                is_supporting_document: true,
                type: value?.type,
              }
            : null,
      };
      handleQuesAnswer({ obj, realQuestion: question });
    }
  };

  const placeholderSize = { inputProps: { sx: { fontSize: "14px" } } };
  const labelSize = { style: { fontSize: "14px" } };

  return (
    <Box
      mt={2}
      sx={{
        pointerEvents: isFrom === "publishedSurvey" ? "none" : "auto",
      }}
    >
      <form
        noValidate
        style={{ display: "flex", gap: "25px", alignItems: "center" }}
      >
        <TextField
          id="start-date"
          label={hasRange ? "Start Date" : "Select Date"}
          type="date"
          InputLabelProps={{ shrink: true }}
          value={formatDate(data.startDate)}
          onChange={(e) => handleChange("startDate", e.target.value)}
          variant="outlined"
          color="primary"
          name="startDate"
          style={{ pointerEvents: event }}
          size="small"
          InputProps={placeholderSize}
        />
        {hasRange && (
          <TextField
            id="end-date"
            label="End Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={formatDate(data.endDate)}
            onChange={(e) => handleChange("endDate", e.target.value)}
            variant="outlined"
            color="primary"
            name="endDate"
            style={{ pointerEvents: event }}
            size="small"
          />
        )}
      </form>

      {comment && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <AdvancedInputField
            data={data.comment}
            placeholder="Contributor’s comment"
            name="comment"
            handleChange={({ name, value }) => handleChange(name, value)}
          />
        </Box>
      )}

      {hasAttachedDocument && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <DocumentUpload
            value={attachDocument}
            isFrom="surveyTask"
            handleChange={handleChange}
            question={"document"}
          />
        </Box>
      )}
    </Box>
  );
};

export default DatePicker;
